import { createPinia } from "pinia";
import { createApp, defineAsyncComponent, type Plugin } from "vue";
import App from "./App.vue";
import { router } from "./router";
// vue-sonner 2.x ships its stylesheet separately and nothing pulled it in, so
// every toast rendered as unstyled text in the document flow -- `position` is
// CSS, so they landed bottom-left whatever the Toaster was told. Imported
// before our own sheet so Tailwind's layers can still override it.
import "vue-sonner/style.css";
import "./assets/main.css";
import VueApexCharts from "vue3-apexcharts";
import vue3GoogleLogin from "vue3-google-login";

const isWorkshop = import.meta.env.DEV && window.location.pathname.startsWith("/dev/");
const app = createApp(isWorkshop ? defineAsyncComponent(() => import("./dev/DevApp.vue")) : App);

app.use(createPinia());
app.use(router);

app.use(vue3GoogleLogin, {
	clientId: "807611619374-8t882rlcljne4vft3ffujs60fmoo79k4.apps.googleusercontent.com"
});
// The package types its default export as Component & Plugin, which app.use's
// overloads cannot resolve; its install only registers <apexchart>.
app.use(VueApexCharts as Plugin);

app.mount("#app");
